var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import DataForm from "~/components/common/data-form.vue";
import { Dependencies } from "~/core/decorator";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { Prop, Emit } from "vue-property-decorator";
import { CaseDistributeService } from "~/services/dataimp-service/case-distribute.service";
var UserBatchAllocate = /** @class */ (function (_super) {
    __extends(UserBatchAllocate, _super);
    function UserBatchAllocate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    UserBatchAllocate.prototype.onPreStep = function () { };
    UserBatchAllocate.prototype.close = function () { };
    UserBatchAllocate.prototype.mounted = function () { };
    UserBatchAllocate.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        this.caseDistributeService
            .groupBatchConfirmDistribute(this.distributeConfigModel)
            .subscribe(function (data) {
            _this.$message.success("分案成功");
            _this.loading = false;
            _this.close();
        }, function (err) {
            _this.loading = false;
        });
    };
    __decorate([
        Dependencies(CaseDistributeService)
    ], UserBatchAllocate.prototype, "caseDistributeService", void 0);
    __decorate([
        Prop()
    ], UserBatchAllocate.prototype, "distributeConfigModel", void 0);
    __decorate([
        Emit("preStep")
    ], UserBatchAllocate.prototype, "onPreStep", null);
    __decorate([
        Emit("close")
    ], UserBatchAllocate.prototype, "close", null);
    UserBatchAllocate = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                DataGrid: DataGrid,
                DataGridItem: DataGridItem
            }
        })
    ], UserBatchAllocate);
    return UserBatchAllocate;
}(Vue));
export default UserBatchAllocate;
